import { ROOT, MAPSERVER_URL, MAPSERVER_ROOT_DIR, PROXY_MAPSERVER_URL } from '../constants/root';
import { buildQueryString } from '../businessLogic/util';

export function drawRects(rects, map) {
	// Create new rect
	const coordinates = [];
	rects.map((r) => r.nw.lat && r.nw.lng && r.se.lat && r.se.lng
		? coordinates.push([
			[parseFloat(r.nw.lng), parseFloat(r.se.lat)],
			[parseFloat(r.se.lng), parseFloat(r.se.lat)],
			[parseFloat(r.se.lng), parseFloat(r.nw.lat)],
			[parseFloat(r.nw.lng), parseFloat(r.nw.lat)],
			[parseFloat(r.nw.lng), parseFloat(r.se.lat)]
		]) : null);
	map.data.addGeoJson({
		type: "Feature",
		id: "CUSTOM_RECT",
		geometry: { coordinates: coordinates, type: "Polygon" }
	});
	const feature = map.data.getFeatureById("CUSTOM_RECT");
	map.data.overrideStyle(feature, { draggable: true, clickable: false, fillColor: "blue", strokeColor: "blue" });
	// return true;
}

export function drawPoints(points, map) {
	const coordinates = [];
	points.map((p) => p.lat && p.lng ? coordinates.push([parseFloat(p.lng), parseFloat(p.lat)]) : null);
	map.data.addGeoJson({
		type: "Feature",
		id: "CUSTOM_POINT",
		geometry: { coordinates: coordinates, type: "MultiPoint" }
	});
	const feature = map.data.getFeatureById("CUSTOM_POINT");
	map.data.overrideStyle(feature, { draggable: true });
	// return true;
}

export function drawGeom(map, geom, id, shapeType, name = "", callback) {
	map.data.addGeoJson({
		type: "Feature",
		id: id,
		geometry: geom
	});
	const feature = map.data.getFeatureById(id);
	map.data.overrideStyle(feature, {
		title: name,
		fillColor: shapeType === 4 ? "red" : "yellow",
		strokeColor: shapeType === 4 ? "red" : "yellow",
		clickable: false
	});
	callback();
}

export function parseLocations(shapes) {

	// Pre-defined locations
	const sectors = [];
	const localities = [];
	const samplingPoints = [];

	// Custom locations
	const points = [];
	const rects = [];

	shapes.map((s) => {
		if ( s.type === 6 ) samplingPoints.push({label: s.name, value: s.id});
		if ( s.type === 5 ) sectors.push({label: s.name, value: s.id});
		if ( s.type === 4 ) localities.push({label: s.name, value: s.id});
		if ( s.type === 3 && s.geom !== "" ) {
			JSON.parse(s.geom).coordinates.map((p) => {
				points.push({lat: p[1].toString(), lng: p[0].toString()});
			});
		}
	});
	return { sectors, points, localities, rects, samplingPoints };
}

export const generatePointGallery = (img) => {
	return img.map((i) => {
		return { src: `${ROOT}/picture/${i.src}/`, caption: i.caption };
	});
};

export const renderMapServerUrl = (file, layersParam, bbox) => {
	if ( file === "" || layersParam === "" ) {
		throw Error("'File' and 'layersParam' must be valid.");
	}

	const url =
		MAPSERVER_URL +
		buildQueryString(
			{REQUEST: "GetMap"},
			{SERVICE: "WMS"},
			{MAP: file},
			{LAYERS: layersParam},
			{srs: "EPSG:4326"},
			{BBOX: bbox},
			{WIDTH: "256"},
			{HEIGHT: "256"},
			{FORMAT: "image/png"},
			{version: "1.1.1"},
		);

	return url;
};

export const renderProxiedMapServerUrl = (proxyLayerName, bbox) => {
	if ( proxyLayerName === "" ) {
		throw Error("'proxyLayerName' must be valid.");
	}

	const url =
		PROXY_MAPSERVER_URL +
		buildQueryString(
			{REQUEST: "GetMap"},
			{SERVICE: "WMS"},
			{LAYERS: proxyLayerName},
			{srs: "EPSG:4326"},
			{BBOX: bbox},
			{WIDTH: "256"},
			{HEIGHT: "256"},
			{FORMAT: "image/png"},
			{version: "1.1.1"},
			{styles: ""},
			{TRANSPARENT: "TRUE"},
			{EXCEPTIONS: "application%2Fvnd.ogc.se_inimage"},
		);

	return url;
};

export const getMapServerParams = (layer) => {
	let file, layersParam, name, projeto, projetoNumero, proxyLayerName;

	file = `${MAPSERVER_ROOT_DIR}${layer.path}${layer.mapfilename}`;
	layersParam = layer.layers;
	proxyLayerName = layer.proxy_layer_name;
	name = layer.name;
	projetoNumero = layer.projeto;
	projeto = projetoNumero === 1 ? "Mariana" : "Brumadinho";

	return { file, layersParam, name, projeto, projetoNumero, proxyLayerName };
};

export const generateLayer = (google, layer) => {
	return new google.maps.ImageMapType({
		getTileUrl: (coord, zoom) => {
			const proj = google.map.getProjection();
			const zfactor = Math.pow(2, zoom);

			// get Long Lat coordinates
			const top = proj.fromPointToLatLng(
				new google.maps.Point(coord.x * 256 / zfactor, coord.y * 256 / zfactor)
			);
			const bot = proj.fromPointToLatLng(
				new google.maps.Point((coord.x + 1) * 256 / zfactor, (coord.y + 1) * 256 / zfactor)
			);

			// Create the Bounding Box string
			const bbox = `${top.lng()},${bot.lat()},${bot.lng()},${top.lat()}`;

			const { file, layersParam, proxyLayerName } = getMapServerParams(layer);

			const url = layer.is_proxied
			? renderProxiedMapServerUrl(proxyLayerName, bbox)
			: renderMapServerUrl(file, layersParam, bbox);

			return url;
		},
		tileSize: new google.maps.Size(256, 256),
		opacity: 1,
		isPng: true
	});
};

export const readLayerBounds = (json, xmlDoc) => {
	let bounds = { maxy: [], miny: [], minx: [], maxx: [] };

	let layersElements = xmlDoc.getElementsByTagName("Layer");

	Array.from(layersElements).map(lll => {
		let LatLonBoundingBox = lll.getElementsByTagName("LatLonBoundingBox")[0];
		if (!LatLonBoundingBox) return;

		let attrMaxy = Number(LatLonBoundingBox.getAttribute('maxy'));
		let attrMiny = Number(LatLonBoundingBox.getAttribute('miny'));
		let attrMinx = Number(LatLonBoundingBox.getAttribute('minx'));
		let attrMaxx = Number(LatLonBoundingBox.getAttribute('maxx'));
		if (attrMaxy === -1 && attrMiny === -1 && attrMinx === -1 && attrMaxx === -1) return;

		bounds.maxy.push(attrMaxy);
		bounds.miny.push(attrMiny);
		bounds.minx.push(attrMinx);
		bounds.maxx.push(attrMaxx);
	});

	const bbox = {
		north: Math.max(...bounds.maxy),
		south: Math.min(...bounds.miny),
		west: Math.min(...bounds.minx),
		east: Math.max(...bounds.maxx)
	};

	return bbox;
};


// WEBPACK FOOTER //
// ./src/businessLogic/map.js